"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authSuiteEmployeeAccessService = exports.AuthSuiteEmployeeAccessService = void 0;
var auth_suite_employee_access_service_1 = require("./auth-suite-employee-access-service");
Object.defineProperty(exports, "AuthSuiteEmployeeAccessService", { enumerable: true, get: function () { return auth_suite_employee_access_service_1.AuthSuiteEmployeeAccessService; } });
Object.defineProperty(exports, "authSuiteEmployeeAccessService", { enumerable: true, get: function () { return auth_suite_employee_access_service_1.authSuiteEmployeeAccessService; } });
